import { ErrorScreen } from '@/components/ErrorScreen'

export function NotFoundPage() {
  return <ErrorScreen variant="not-found" showHomeLink />
}
